import 'apps/pathways/styles/start/components/result-set.scss';
import React, { Fragment } from 'react';
import withData from 'util/hoc/with-data';
import withUser from 'util/hoc/with-user';
import Query from 'library/util/query';
import PropTypes from 'prop-types';
import { jsonToInputParams } from 'library/util/graph';
import { resolve } from 'library/helpers/path-resolver';
import Result from 'apps/pathways/start/components/result';


const checkLatLong = (obj) => {
  const object = JSON.parse(JSON.stringify(obj));
  for (const key in obj) {
    if (obj[key] === '') {
      delete object[key];
    }
    if (key === 'location_name') {
      delete object.location_name;
    }
  }
  return object;
};


class ResultSet extends React.Component {
  mapResults = (data) => (
    <Result
      hideMatchScores={this.props.hideMatchScores}
      buildPathway={this.props.buildPathway}
      key={data.id}
      loading={this.props.graph_loading}
      like={this.likeCareer}
      dislike={this.dislikeCareer}
      neutralize={this.neutralizeCareer}
      data={data}

    />
  )

  componentDidUpdate(prevProps) {
    if (prevProps.graph_loading !== this.props.graph_loading) {
      const { whatIsLoading, section, graph_loading } = this.props;
      whatIsLoading(section, graph_loading);
    }
  }

  updateOccupationLikes = (newOccupation) => {
    const occupations = resolve(this.props, 'graph_data/occupations/results', []);
    for (const occupation of occupations) {
      if (occupation.id === newOccupation.id) {
        occupation.liked = newOccupation.liked;
        occupation.disliked = newOccupation.disliked;
        break;
      }
    }

    const data = resolve(this.props, 'graph_data', {occupations:{results:[]}});
    data.occupations.results = occupations;
    this.props.graph_update(data);
  }

  likeCareer = async (id) => {
    await this.ldnCareer('like', id);
  }
  dislikeCareer = async (id) => {
    await this.ldnCareer('dislike', id);
  }
  neutralizeCareer = async (id) => {
    await this.ldnCareer('neutralize', id);
  }

  ldnCareer = async (type='like', id) => {
    try {
      await this.updateOccupationLikes({
        id: id,
        liked: type==='like',
        disliked: type==='disliked'
      });

      const { data } = await Query(`
        mutation {
          ${type}_occupation(user_id: ${this.props.user.id}, occupation_id: "${id}") {
            success,
            occupation {
              id,
              liked,
              disliked
            }
          }
        }
      `);
      if (resolve(data, `${type}_occupation/success`, false)) {
        await this.updateOccupationLikes(resolve(data, `${type}_occupation/occupation`, {}));
      }
    } catch (e) {
      console.error(e);
    }
  }

  get results() {
    const {
      graph_data,
      graph_loading,
      limit
    } = this.props;

    const r = resolve(graph_data, 'occupations/results', []).slice(0,limit);
    if (graph_loading && r.length < limit) {
      for (let i = 0; i < limit; i++) {
        if (!r[i]) {
          r[i] = {
            loading: true
          };

        }
      }
    } else {
      for (let i = 0; i < limit; i++) {
        if (r[i]) {
          r[i].recentSurvey = resolve(this.props, 'graph_data/account/most_recent_completed_assessment/id', 0);
          r[i].softSkillIndex=resolve(this.props, 'softSkillIndex', 1);
        }
      }
    }

    return r;
  }

  render() {
    const {
      graph_data,
      graph_loading,
      limit,
      defaultHawtCareer,
      showMore=()=>{}
    } = this.props;

    let results = this.results;

    if (defaultHawtCareer && !graph_loading) {
      const hawtie = {...resolve(graph_data, 'defaultHawt', {})};
      if (limit == 1) {
        results = [hawtie] ;
      } else {
        results.pop();
        results.push(hawtie);
        results = results.sort((x,y) => {
          return x.id == defaultHawtCareer ? -1 : y.id == defaultHawtCareer ? 1 : 0;
        });
      }
    }

    return (
      <Fragment>
        {
          resolve(graph_data, 'occupations/pagination/total', limit) === 0 && !graph_loading && !defaultHawtCareer
            ? (
              <div className="pathways-start-result-set-empty">
                It looks like you have no results. Try adjusting your filters to broaden your search or refreshing this page. It can take up to 30 seconds to calculate new matches after taking the assessment or updating your experience.
              </div>
            )
            : null
        }
        <div className="pathways-start-result-set">
          {
            results.map(this.mapResults)
          }
        </div>
        {
          results.length < resolve(graph_data, 'occupations/pagination/total', limit)
            ? (
              <a aria-label='Show more option, new careers will show up above. press shift tab to focus on them' href="javascript:void(0)" onClick={showMore}>show more</a>
            ) : null
        }
      </Fragment>
    );
  }
}

ResultSet.propTypes = {
  graph_data: PropTypes.object,
  graph_loading: PropTypes.bool,
  limit: PropTypes.number,
  user: PropTypes.object,
  showMore: PropTypes.func,
  graph_update: PropTypes.func,
  buildPathway: PropTypes.func,
  result_loading: PropTypes.func,
  section: PropTypes.string,
  whatIsLoading: PropTypes.func,
  hideMatchScores: PropTypes.bool,
  defaultHawtCareer: PropTypes.any
};

ResultSet.dependantPropPath = [
  'preferences/education',
  'preferences/industry',
  'preferences/interests',
  'preferences/lat',
  'preferences/long',
  'preferences/min_salary',
  'only',
  'title',
  'limit',
  'hawt',
  'liked',
  'disliked',
  'change'
];
ResultSet.showLoadingOnDependantPropChange = true;

ResultSet.query = async (token, props) => {
  let defaultHawt = props.defaultHawtCareer
    ? `defaultHawt: occupation(id: "${props.defaultHawtCareer}") {
      id
      title
      match
      hawt
      opportunity
      liked,
      disliked,
      location {
        title
      }
      education {
        minimum_requirement
      }
      employment {
        jobs_per_1000
        projected_employment
        total_employed
      }
      description
      industries {
        title
      }
      wage {
        mean_annual_rate
        mean_hourly_rate
        median_annual_rate
        median_hourly_rate
      }
      softSkills: onet_occupation {
         name
         id
         target {
           id
         }
       }
      hardSkills: skills(classification: "hard") {
        id
        name
      }
    }`
    : '';

  return await Query(`
    {
      ${defaultHawt}
      occupations (${jsonToInputParams(checkLatLong({order: 'desc', order_by: 'match', limit:resolve(props, 'limit', 3), ...resolve(props, 'preferences', {}), title: props.title, liked: props.liked, disliked: props.disliked, hawt: props.hawt }))}) {
        pagination {
          total
        }
        results {
          id
          title
          match
          hawt
          opportunity
          liked
          disliked
          softSkills: onet_occupation{
            name
            id
            target {
              id
             }
           }
          location {
            title
          }
          education {
            minimum_requirement
          }
          employment {
            jobs_per_1000
            projected_employment
            total_employed
          }
          description
          industries {
            title
          }
          wage {
            mean_annual_rate
            mean_hourly_rate
            median_annual_rate
            median_hourly_rate
          }
          hardSkills: skills(classification: "hard") {
            id
            name
          }
        }
      }
      account {
        most_recent_completed_assessment {
          id
      }
    }
  }
  `);
};

export default withUser(withData(ResultSet));
